import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Duration } from '@js-joda/core';
import { useNow, FREQUENCY_SECONDS } from '@rad/hooks';
import { formatDateLong } from '@rad/utility/formatting';
const TourCountdown = (props) => {
    const now = useNow(FREQUENCY_SECONDS(1));
    // The page moves on to the tour itself once a minute, so the count can pass the start first: it
    // holds at zero until then rather than running negative.
    const remaining = now.isBefore(props.starts) ? Duration.between(now, props.starts) : Duration.ZERO;
    // Seconds, so the last minute still counts down instead of reading all zeros.
    const units = [
        { label: 'Days', value: remaining.toDays() },
        { label: 'Hours', value: remaining.toHours() % 24 },
        { label: 'Minutes', value: remaining.toMinutes() % 60 },
        { label: 'Seconds', value: remaining.seconds() % 60 },
    ];
    return (_jsx("div", { className: "tour-countdown", "aria-label": `Counting down to ${formatDateLong(props.starts)}`, children: units.map(unit => (_jsxs("div", { className: "tour-countdown-unit", children: [_jsx("span", { className: "tour-countdown-value", children: unit.value }), _jsx("span", { className: "tour-countdown-label", children: unit.label })] }, unit.label))) }));
};
export default TourCountdown;
